class NewcomerFindPower{
    constructor({el}) {
        this.DOM = {
            cls: el,
            el: $(el)
        }
        if ($(this.DOM.cls).length === 0) {
            return;
        }
        this.init();
    }
    init(){
        $(`${this.DOM.cls} .higher-btn`).on('click',function(){
            $('.find-main-pop').css('display', 'block');
            $('body').css('overflow', 'hidden');
        })
        $('.pop-close-icon').on('click',function(){
            $('.find-main-pop').css('display', 'none');
            $('body').css('overflow', 'auto');
        })
    }
}
new NewcomerFindPower({el: '.newcomer-find-power'})

class NewcomerHigherOutput {
    constructor({el}) {
        this.DOM = {
            cls: el,
            el: $(el)
        }
        if ($(this.DOM.cls).length === 0) {
            return;
        }
        this.init();
    }
    init(){
        $(`${this.DOM.cls} .higher-btn`).on('click',function(){
            $('.newcomer-main-pop').css('display', 'block');
            $('body').css('overflow', 'hidden');
            if(window.innerWidth < 1024) {
                setTimeout(() => {
                    $('.newcomer-main-pop .higher-output-box').css('transform', 'translateY(0)');
                }, 50);
            }
        })
        $('.pop-close-icon').on('click',function(){
            $('.newcomer-main-pop').css('display', 'none');
            $('body').css('overflow', 'auto');
            if(window.innerWidth < 1024) {
            $('.newcomer-main-pop .higher-output-box').css('transform', 'translateY(100%)');
            }
        })
    }
}
new NewcomerHigherOutput({el: '.newcomer-higher-output'})

class NewcomerCalculator {
    constructor(options = {}) {
        this.el = options.el || '.newcomer-calculator';
        this.maxPower = 0;
        this.acConsumption = 0;
        this.capacity = 0;
        this.productSelected = false;
        this.init();
    }

    init() {
        const $calculator = $(this.el);
        if (!$calculator.length) return;
        try {
        this.initProductSelector();
        } catch (error) {
        console.error(error);
        }

        // 初始化计算器功能
        this.initCalculator();
    }

    // 初始化产品选择器
    initProductSelector() {
        const $calculator = $(this.el);
        const $productSelector = $calculator.find('.product-selector');
        const $productItem = $productSelector.find('.product-name');
        const $dropdownList = $productSelector.find('.product-dropdown-list');
        // 点击产品项显示/隐藏下拉列表
        $productItem.on('click', () => {
        $dropdownList.css('display','block');
        });

        // 点击下拉项选择产品
        $dropdownList.on('click', '.dropdown-item', (e) => {
            const $selectedItem = $(e.currentTarget);
            const maxPower = $selectedItem.data('max-power');
            const acConsumption = $selectedItem.data('ac-consumption');
            const itemImage = $selectedItem.data('image');
            const itemTitle = $selectedItem.data('short-name');
            const itemEquipment = $selectedItem.data('equipment');
            const itemCapacity = $selectedItem.data('capacity');
            this.efficiency = $selectedItem.data('efficiency');
            this.acConsumption = acConsumption;
            this.capacity = itemCapacity;
            this.maxPower = maxPower;
            this.productSelected = true;
            // 检查输入框是否有值，更新按钮状态
            const $input = $('.power-inp');
            const inputValue = $input.val();
            const $btnEnter = $('.btn-enter');
            $btnEnter.attr('disabled', !inputValue);

            // 更新输入框属性
            $input.attr('max', maxPower);
            $input.attr('data-max-power', maxPower);
            $input.attr('data-ac_consumption', acConsumption);

            $('.product-image').html(`<img src="${itemImage}" alt="${itemTitle}">`);
            $('.product-name .item-title').text(itemTitle);

            // 更新产品规格信息 - 修正替换方法
            let formattedSpecs = itemEquipment;
            if (formattedSpecs) {
                formattedSpecs = formattedSpecs.replace('${capacity}', itemCapacity).replace('${power}', maxPower);
                $('.product-specs').text(formattedSpecs);
            }
            $dropdownList.css('display', 'none');
        });

        // 点击其他区域关闭下拉列表
        $(document).on('click', (e) => {
        if (!$(e.target).closest('.product-selector').length) {
            $dropdownList.css('display','none');
        }
        });
    }
    // 初始化计算器功能
    initCalculator() {
        const $calculator = $(this.el);
        const $powerInp = $calculator.find('.power-inp');
        const $btnEnter = $calculator.find('.btn-enter');
        const $errorTips = $calculator.find('.error-tips');
        const $errorText = $errorTips.data('error-tip');
        const $resultNumber = $calculator.find('.result-number');
        const $btnTips = $calculator.find('.btn-tips');
        const hourText = $resultNumber.text().split(' ')[1]; // 获取小时文本

        // 输入框获得焦点时添加active类
        $powerInp.on('focus', function() {
        $(this).parent().addClass('active');
        });

        // 输入框失去焦点时移除active类
        $powerInp.on('blur', function() {
        $(this).parent().removeClass('active');
        });

        // 输入框输入事件
        $powerInp.on('input', throttle(() => {
        const inpVal = $powerInp.val();
        const btnOnceShow = $btnTips.attr('data-once-show');

        // 只有在同时满足已选择产品和已输入功率值时才启用按钮
        if (inpVal && this.productSelected) {
            $btnEnter.attr('disabled', false);
            if (btnOnceShow === 'false') {
            $btnTips.css('display','block');
            $btnTips.attr('data-once-show', 'true');
            }
        } else {
            $btnEnter.attr('disabled', true);
            $btnTips.hide();
        }
        }, 300));

        // 计算函数
        const calculateRunningTime = () => {
        $btnTips.hide();

        const currVal = $powerInp.val();
        if (!currVal) {
            $resultNumber.text(`2 ${hourText}`);
            $errorTips.hide();
            return;
        }

        if (Number(currVal) > Number(this.maxPower)) {
            $errorTips.text($errorText.replace('${power}', this.maxPower));
            $errorTips.show();
            return;
        }

        $errorTips.hide();
        const result = window.getRunningTime(
            Number(currVal),
            Number(this.capacity),
            Number(this.efficiency),
            Number(this.acConsumption)
        );
        // 使用CountUp实现数字动画效果
        this.countUpAnimation('result-number', result, hourText);
        };

        // 等号按钮点击事件
        $btnEnter.on('click', calculateRunningTime);

        // 回车键触发计算
        $powerInp.on('keypress', function(event) {
        if (event.which === 13) {
            calculateRunningTime();
        }
        });

        // 视口滚动时检测输入框是否在视口内
        $(window).scroll(throttle(function() {
        if (window.Jackery && window.Jackery.Utils && window.Jackery.Utils.isElementInViewport($powerInp[0])) {
            $powerInp.focus();
        } else {
            $powerInp.blur();
        }
        }, 300));
    }

    // 数字动画效果
    countUpAnimation(elementClass, result, decimalPlaces = 1) {
        const $element = $(this.el).find(`.${elementClass}`);
        const $numElement = $element.find('.result-num');

        const options = {
        decimalPlaces: decimalPlaces,
        duration: 1
        };

        if (Shopify.currency.active === 'EUR') {
        options.separator = '.';
        options.decimal = ',';
        }
        const uniqueId = `countup-${Math.random().toString(36).substr(2, 9)}`;
        $numElement.attr('id', uniqueId);

        const numVal = new CountUp(uniqueId, 0, Number(result), 0, 1.2, options);
        if (!numVal.error) {
        numVal.start();
        } else {
        console.error(numVal.error);
        }
    }
}
new NewcomerCalculator({el: '.newcomer-calculator'})